export const trans_4_2=[
    {
      id:1,
      english:'How old are you? I am 18 years old',
      vietnamese:'Bạn bao nhiêu tuổi? Tôi năm nay  18 tuổi',
      user_message:''
    },
    {
      id:2,
      english:'Who is that? That is Mai anh. She is 20 years old',
      vietnamese:'Kia là ai? Kia là Mai Anh. Cô ấy năm nay 20 tuổi',
      user_message:''
    },
    {
      id:3,
      english:'Mr. George! This is my mother, she is 40 years old',
      vietnamese:'Thưa thầy George! Đây là mẹ của em, năm nay mẹ em 40 tuổi',
      user_message:''
    },
    {
      id:4,
      english:'Tommorow, we are going to have a meeting at 10h',
      vietnamese:'Ngày mai, chúng ta có một cuộc họp vào lúc 10h sáng',
      user_message:''
    }
    ,
    {
      id:5,
      english:'Our director is French',
      vietnamese:'Giám dốc của chúng ta là người nước Pháp',
      user_message:''
    },
    {
      id:6,
      english:'Our class has 20 students',
      vietnamese:'Lớp học của chúng ta có 20 học sinh',
      user_message:''
    },
    {
        id:7,
        english:'This year, Mai is 10 years old',
        vietnamese:'Năm nay Mai 10 tưởi',
        user_message:''
    },
    {
      id:8,
      english:' How many pages does your book have?',
      vietnamese:'Quyển sách của bạn có bao nhiêu trang?',
      user_message:''
    },
    {
      id:9,
      english:'In Vietnam, at the age of six, students are in grade 1',
      vietnamese:'Ở Việt Nam 6 tuổi học lớp 1',
      user_message:''
    },
    {
      id:10,
      english:'This is my secretary',
      vietnamese:'Đây là thư kí của tôi',
      user_message:''
    },

  ]